import { upperFirst } from "../string";

export * from "./getMonthNameByMonthIndex";

export function getDateFromDateString(dateString) {
  const date = new Date(dateString + " 00:00:00");
  return date;
}

/**
 * Gets day number from date
 * @param string date Date as YYYY-MM-DD
 * @returns number
 */
export function getDayFromDate(dateString) {
  const date = getDateFromDateString(dateString);
  return date.getDate();
}

export function getMonthFromDate(dateString, locale = "pl-PL") {
  const date = getDateFromDateString(dateString);
  return upperFirst(date.toLocaleDateString(locale, { month: "long", year: "numeric" }));
}

export function getDaysDiff(date1, date2 = new Date()) {
  if (typeof date1 !== "object") {
    date1 = getDateFromDateString(date1);
  }

  if (typeof date2 !== "object") {
    date2 = getDateFromDateString(date2);
  }

  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}

export function addDaysToDate(days, date = new Date()) {
  if (typeof date !== "object") {
    date = getDateFromDateString(date);
  }

  date.setDate(date.getDate() + days);
  return date;
}

export function getDateStringFromDate(date) {
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
    .getDate()
    .toString()
    .padStart(2, "0")}`;
}

/**
 * Returns the first day of the given month (counting from current month) in YYYY-MM-DD format.
 * monthsFromNow = 1 is current month
 * @returns {string} The first day of the current month in YYYY-MM-DD format.
 */
export function getFirstDayOfMonthCountingFromCurrentMonth(monthsFromNow = 1) {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + monthsFromNow).toString().padStart(2, "0");

  return `${year}-${month}-01`;
}

/**
 * Returns the last day of the given month in YYYY-MM-DD format.
 * monthsFromNow = 1 is current month
 *
 * @returns {string} The last day of the current month (counting from current month) in YYYY-MM-DD format.
 */
export function getLastDayOfMonthCountingFromCurrentMonth(monthsFromNow = 1) {
  const date = new Date();
  date.setMonth(date.getMonth() + monthsFromNow);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const lastDay = new Date(year, month, 0).getDate();

  return `${year}-${month}-${lastDay.toString().padStart(2, "0")}`;
}

export function areDatesFromTheSameMonth(date1, date2) {
  return getMonthFromDate(date1) === getMonthFromDate(date2);
}
